import Webcam from 'react-webcam';
import { CameraOptions, useFaceDetection } from 'react-use-face-detection';
import FaceDetection from '@mediapipe/face_detection';
import { Camera } from '@mediapipe/camera_utils';
import { useWindowDimensions } from '../../../hooks/ui';
import React, { useCallback, useEffect, useState } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { CARTERA_API_HOST } from '../../../api/api';
import Tick from '../../../assets/icons/Tick';
import DefaultButton from '../../../components/default-button/DefaultButton';

// const width = 500;
// const height = 500;

export const FaceRecognition = (): JSX.Element => {
    const [searchParams] = useSearchParams();
    const token = searchParams.get('token');
    const { width, height } = useWindowDimensions();
    const [keepCapturing, setKeepCapturing] = useState(true)
    const [success, setSuccess] = useState(false);

    const { webcamRef, boundingBox, isLoading, detected, facesDetected } = useFaceDetection({
        faceDetectionOptions: {
            model: 'short',
        },
        faceDetection: new FaceDetection.FaceDetection({
            locateFile: (file: any) => `https://cdn.jsdelivr.net/npm/@mediapipe/face_detection/${file}`,
        }),
        camera: ({ mediaSrc, onFrame }: CameraOptions) =>
            new Camera(mediaSrc, {
                onFrame,
                width,
                height,
            }),
    });

    const captureAndSend = async () => {
        try {
            //@ts-ignore
            const imageSrc = webcamRef?.current?.getScreenshot();
            if (!imageSrc) return;

            setKeepCapturing(false);

            // Convert base64 to Blob
            const base64Response = await fetch(imageSrc);
            const imageBlob = await base64Response.blob();

            // Prepare FormData
            const formData = new FormData();
            formData.append('image', imageBlob, 'face_capture.jpg');

            const responseRaw = await fetch(`${CARTERA_API_HOST}/api/v1/users/update-face-verification`, {
                method: 'POST',
                body: formData,
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            })

            const response = await responseRaw.json()

            if (response.success) {
                setSuccess(true)
            }

            // Send to API
            // fetch('https://your-api-url.com/upload', {
            //     method: 'POST',
            //     body: formData,
            // })
            //     .then((res) => res.json())
            //     .then((data) => console.log('Upload success:', data))
            //     .catch((err) => console.error('Upload error:', err));
        } catch (e) {
            console.error(e);
        }
    };

    useEffect(() => {
        if (facesDetected > 0) {
            const box = boundingBox[0]; // First detected face
            if (!box) return;

            // Check if face is in center (threshold: 40-60% of the frame)
            const isCentered =
                box.xCenter > 0.40 && box.xCenter < 0.60 && box.yCenter > 0.40 && box.yCenter < 0.60;

            if (isCentered) {
                captureAndSend();
            }
        }
    }, [facesDetected, boundingBox?.[0]?.xCenter, boundingBox?.[0]?.yCenter]);

    return (
        <div className='w-full h-full min-h-screen flex flex-col'>
            <div className='flex flex-row px-4 py-4 shadow-[0px_0px_8px_0px_rgba(46,68,119,0.12)]'>
                <span className='font-medium text-[22px] leading-7 text-valley-black'>
                    Верификация лица
                </span>
            </div>
            <div className='flex flex-row flex-1 justify-center items-center relative'>
                {success && (
                    <div className='flex flex-col px-4 text-center gap-3'>
                        <Tick additionalStyle='text-valley-dark-green' />
                        <span className='font-semibold text-lg text-valley-black'>
                            Подзравляем! Вы успешно верифицировали свою личность
                        </span>
                        <a href='kbtu-uniq://' className='flex items-center gap-1 py-1 border rounded-lg font-semibold bg-valley-main max-h-fit justify-center text-white'>
                            Вернуться в приложение
                        </a>
                    </div>
                )}
                {keepCapturing && (
                    <React.Fragment>
                        <div className='absolute w-full flex flex-row items-center justify-center top-10 px-4'>
                            <div className='flex flex-row items-center justify-center text-center px-4 py-2 bg-valley-black shadow-[0px_0px_8px_0px_rgba(46,68,119,0.12)]'>
                                <span className='font-medium text-white'>
                                    Пожалуйста, расположите лицо в центре кадра
                                </span>
                            </div>
                        </div>
                        {/* {boundingBox.map((box: any, index: number) => (
                            <div
                                key={`${index + 1}`}
                                style={{
                                    border: '4px solid red',
                                    position: 'absolute',
                                    top: `${box.yCenter * 100}%`,
                                    left: `${box.xCenter * 100}%`,
                                    width: `${box.width * 100}%`,
                                    height: `${box.height * 100}%`,
                                    zIndex: 1,
                                }}
                            />
                        ))} */}
                        <Webcam
                            ref={webcamRef}
                            forceScreenshotSourceSize
                            style={{
                                height: height - 60,
                                width,
                            }}
                        />
                    </React.Fragment>
                )}
            </div>
        </div>
    );

    // return (
    //     <div>
    //         <p>{`Loading: ${isLoading}`}</p>
    //         <p>{`Face Detected: ${detected}`}</p>
    //         <p>{`Number of faces detected: ${facesDetected}`}</p>
    //         <div style={{ width, height, position: 'relative' }}>
    //             {boundingBox.map((box: any, index: number) => (
    //                 <div
    //                     key={`${index + 1}`}
    //                     style={{
    //                         border: '4px solid red',
    //                         position: 'absolute',
    //                         top: `${box.yCenter * 100}%`,
    //                         left: `${box.xCenter * 100}%`,
    //                         width: `${box.width * 100}%`,
    //                         height: `${box.height * 100}%`,
    //                         zIndex: 1,
    //                     }}
    //                 />
    //             ))}
    //             <Webcam
    //                 ref={webcamRef}
    //                 forceScreenshotSourceSize
    //                 style={{
    //                     height,
    //                     width,
    //                     position: 'absolute',
    //                 }}
    //             />
    //         </div>
    //     </div>
    // );
};